import { REDUX_ACTIONS } from '../../../shared/config/constants';

const initialState = {
  syncSignatureHarvestStatus: 'idle', // idle, loading, error
  syncSignatureHarvestResponseMessage: '',
  syncSignatureHarvestDivision: ''
};

const epicorSyncSignatureHarvest = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_LOADING:
      return {
        ...state,
        syncSignatureHarvestStatus: 'loading',
        syncSignatureHarvestResponseMessage: action.payload.message,
      };
    case REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_IDLE:
      return {
        ...state,
        syncSignatureHarvestStatus: 'idle',
        syncSignatureHarvestResponseMessage: action.payload.message,
        syncSignatureHarvestDivision: ''
      };
    case REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_ERROR:
      return {
        ...state,
        syncSignatureHarvestStatus: 'error',
        syncSignatureHarvestResponseMessage: action.payload.message,
        syncSignatureHarvestDivision: ''
      };
    case REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_SUCCESS:
      return {
        ...state,
        syncSignatureHarvestStatus: 'success',
        syncSignatureHarvestResponseMessage: action.payload.message,
        syncSignatureHarvestDivision: ''
      };
    case REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_DIVISION:
      return {
        ...state,
        syncSignatureHarvestDivision: action.payload,
        syncSignatureHarvestStatus: 'idle',
        syncSignatureHarvestResponseMessage: '',
      };
    default:
      return state;
  }
};

export default epicorSyncSignatureHarvest;
